import { useState } from "react";
import { PortInStep } from "./portInStep";
import { ValidatePhoneNumberView } from "./ValidatePhoneNumberView";
import type { FieldValues, UseFormMethods } from "react-hook-form";
import { INetwork } from "@interface/IPortinForm";

interface IParams<TFieldValues extends FieldValues = FieldValues> {
    formMethods: UseFormMethods<TFieldValues>;
    phoneNumberSelected: string;
    previousPhoneNumber?: string;
    setIsFinished(): void;
    setCurrentProvider(currentProvider: INetwork): void;
    setPhoneNumberSelected(phoneNumber: string): void;
    namePrefix?: string;
    clearCardError?(): void;
}

export const ValidatePhoneNumber = <TFieldValues extends FieldValues = FieldValues>(props: IParams<TFieldValues>) => {
    const {
        phoneNumberSelected,
        setPhoneNumberSelected,
        previousPhoneNumber,
        setIsFinished,
        setCurrentProvider,
        formMethods,
        namePrefix,
        clearCardError,
    } = props;

    const [portInStep, setPortInStep] = useState(PortInStep.getCode);
    const [hasTooManyAttempt, setHasTooManyAttempt] = useState(false);

    const updatePortInStep = (step: PortInStep) => {
        setPortInStep(step);
    };

    return (
        <ValidatePhoneNumberView
            clearCardError={clearCardError}
            formMethods={formMethods}
            hasTooManyAttempt={hasTooManyAttempt}
            namePrefix={namePrefix}
            phoneNumberSelected={phoneNumberSelected}
            portInStep={portInStep}
            previousPhoneNumber={previousPhoneNumber}
            setCurrentProvider={setCurrentProvider}
            setHasTooManyAttempt={setHasTooManyAttempt}
            setIsFinished={setIsFinished}
            setPhoneNumberSelected={setPhoneNumberSelected}
            updatePortInStep={updatePortInStep}
        />
    );
};
